/* Built In Imports */
import NextLink from 'next/link';
import { useContext, useEffect, useState } from 'react';

/* External Imports */
import { Box, Divider, Flex, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SubscribeContent from '@components/UI/Subscribe/SubscribeContent';
import HeadComponent from '@components/Utility/HeadComponent';
import LikeBookmark from '@components/Utility/LikeBookmark';
import Loader from '@components/Utility/Loader';
import RelatedTags from '@components/Utility/RelatedTags';
import SocialIcon from '@components/Utility/SocialIcon';
import config from '@config';
import { AuthContext } from '@store/auth-context';
// import AdSenseBlock from '@components/UI/AdSenseBlock';

//Constant
import { LangStyle } from 'constants/index';

/* Services */
import {
  getLocale
} from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData
} from 'services/commonService';
import {
  fetchBlogDetailData,
  getWisdomLandingPaths
} from 'services/wisdomService';

/**
 * Renders the Selected Quote Detail Page
 *
 * @function
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageDataDetail -  Selected Quote Detail Page Data
 * @returns {ReactElement} Selected Quote Detail Page
 */
export default function SelectedQuoteDetailPage({
  region,
  language,
  pageDataDetail,
}) {
  // const [currentUserRegion, setCurrentUserRegion] = useState(region);
  const authContext = useContext(AuthContext);
  // const [pageDataDetail, setPageData] = useState(pageDataDetail || []);
  const [isLoader, setIsLoader] = useState(false);

  // const router = useRouter();
  // const { date } = router.query;

  useEffect(() => {
    // const currentRegion = config.locales.find(
    //   locale => locale.region_sf === region
    // ).region;
    authContext.RegionAndLang(region, language);
    // setCurrentUserRegion(currentRegion);
  }, [region]);

  // useEffect(() => {
  //   setPageData(pageDataDetail);
  // }, [pageDataDetail]);

  const NextArrow = props => {
    const { url } = props;
    return (
      <NextLink href={url} passHref legacyBehavior>

        <Link
          cursor="pointer"
          bgSize={{ base: '18px', sm: '20px', md: '33px', lg: '33px' }}
          w="40px"
          h="40px"
          bgPos="center"
          bgRepeat="no-repeat"
          color="transparent"
          bgImage={`url('${config.imgPath}/d/46272/1663649590-right-arrow-big.svg')`}
          mt={{ base: 'unset', md: '10px', lg: '10px' }}
          ml={{ base: '35px', sm: '30px', md: '90px', lg: '90px' }}
        >
        </Link>
      </NextLink>
    );
  };

  const PrevArrow = props => {
    const { url } = props;
    return (
      <NextLink href={url} passHref legacyBehavior>
        <Link
          cursor="pointer"
          bgSize={{ base: '18px', sm: '20px', md: '33px', lg: '33px' }}
          w="40px"
          h="40px"
          bgPos="center"
          bgRepeat="no-repeat"
          color="transparent"
          bgImage={`url('${config.imgPath}/d/46272/1663652057-left-arrow-big.svg')`}
          mt={{ base: 'unset', md: '10px', lg: '10px' }}
          mr={{ base: '35px', sm: '30px', md: '90px', lg: '90px' }}
        >
        </Link>
      </NextLink>
    );
  };

  // const updateCards = (id, flag) => {
  //   const data = {
  //     ...pageDataDetail,
  //     isLiked:
  //       flag === 'likes' ? !pageDataDetail.isLiked : pageDataDetail.isLiked,
  //     isBookmarked:
  //       flag === 'bookmarks'
  //         ? !pageDataDetail.isBookmarked
  //         : pageDataDetail.isBookmarked,
  //   };
  //   // setPageData(data);
  //   consoleLog(pageDataDetail);
  // };

  return pageDataDetail ? (
    <Box pos="relative" float="left" w="100%">
      <HeadComponent
        data={pageDataDetail?._seoMetaTags}
        availableLocals={pageDataDetail?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Box>
        <Breadcrum
          page={pageDataDetail?.breadcrumbs}
          alsoin={pageDataDetail?.alsoin}
          url={pageDataDetail?.url}
          region={region}
          lang={language}
          pageConfig={pageDataDetail?.pageConfig}
        />
      </Box>

      {/* view content section */}
      <Box
        pos="relative"
        float="left"
        w="100%"
        // mt="1vw"
        textAlign="center"
        mb="1vw"
      >
        <Box maxWidth="1300px" margin="0 auto">
          <Box as="section" width="100%" textAlign="center" float="left">
            <Box pos="relative">
              <Box
                clipPath="polygon(0 0, 100% 0, 100% 80%, 0% 100%)"
                bgColor="#000054"
                minHeight="30vw"
                pos="absolute"
                w="100%"
              >
                &nbsp;
              </Box>
              <Flex
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                w="100%"
              >
                <Box
                  pos="relative"
                  float="left"
                  w="100%"
                  textAlign="center"
                  mt="3.5vw"
                  mb="3vw"
                >
                  <Flex
                    w="100%"
                    flexDirection={
                      "base: 'column',sm:'column',md: 'row',lg: 'row'"
                    }
                    justifyContent="center"
                  >
                    {pageDataDetail?.previous?.length && pageDataDetail?.previous[0].url && (
                      <PrevArrow
                        url={
                          pageDataDetail?.previous[0].url
                        }
                      />
                    )}
                    <Box>
                      <Text
                        color="#faf7f0"
                        fontSize={{
                          md: '35px',
                          lg: '45px',
                          sm: '30px',
                          base: '20px',
                        }}
                        pt={{ md: '0', lg: '0', sm: '10px', base: '6px' }}
                        fontFamily="FedraSerifAStdBook"
                      >
                        {pageDataDetail?.title[0]?.value}
                      </Text>
                    </Box>
                    {pageDataDetail.next?.length && pageDataDetail?.next[0].url && (
                      <NextArrow url={pageDataDetail?.next[0].url} />
                    )}
                  </Flex>
                </Box>
                <Box
                  pos="relative"
                  w={{ base: '100%', sm: '100%', md: '50%', lg: '50%' }}
                >
                  {pageDataDetail.heroImage && (
                    <LazyLoadImageComponent
                      alt={
                        pageDataDetail.heroImage[0]?.value?.alt
                          ? pageDataDetail.heroImage[0]?.value?.alt
                          : ''
                      }
                      title={
                        pageDataDetail?.heroImage[0]?.value?.title
                          ? pageDataDetail?.heroImage[0]?.value?.title
                          : ''
                      }
                      src={
                        pageDataDetail?.heroImage[0]?.value?.url
                          ? pageDataDetail?.heroImage[0]?.value.url
                          : ''
                      }
                      // minHeight={{ base: '255px', md: '240px', lg: '405px' }}
                      width="auto"
                      height="auto"
                      minHeight={{ base: '200px', sm: '240px', xl: '405px' }}
                      backgroundColor="#000054"
                    />
                  )}
                </Box>
                <Box
                  pos="relative"
                  w={{ base: '100%', sm: '100%', md: '50%', lg: '50%' }}
                  m="2vw 4vw 0vw 4vw"
                  fontSize={{ base: '20px', md: '20px', lg: '20px' }}
                  lineHeight="1.54"
                  textAlign="center"
                  color="#07033a"
                  fontFamily="FedraSerifAStdBook"
                  p="20px"
                  dir={
                    LangStyle[language]?.direction
                      ? LangStyle[language].direction
                      : 'none'
                  }
                >
                  {pageDataDetail.summary[0].value}
                </Box>
                <Box m="3vw 0">
                  <LazyLoadImageComponent
                    src={`${config.imgPath}/d/46272/1663654954-signature_name.png`}
                    alt="sadhguru signature"
                    title="sadhguru signature"
                    minHeight="105px"
                  />
                </Box>
                {pageDataDetail?.quotesSpecialDay[0]?.value && (
                  <Box
                    m="1vw 0 1vw"
                    fontFamily="FedraSansStd-medium"
                    fontSize="18px"
                    textAlign="center"
                    color="#464038"
                  >
                    {pageDataDetail.quotesSpecialDay[0].value}
                  </Box>
                )}
                <Box mb="50px">
                  <LazyLoadImageComponent
                    src={`${config.imgPath}/d/46272/1663677075-quote-sptr.png`}
                    alt="quote sptr"
                    title="quote sptr"
                    minHeight="27px"
                  />
                </Box>
              </Flex>
            </Box>
            <Box pos="relative" maxW="940px" m="20px auto">
              <Flex
                flexDirection={{
                  base: 'column',
                  md: 'row',
                  sm: 'column',
                  lg: 'row',
                }}
                justifyContent="space-around"
                mb="2vw"
              >
                <Box mb="20px" color="#aea493" fontFamily="FedraSansStd-book">
                  <Box textAlign={{ base: 'center', md: 'left' }}>
                    <Text fontSize="14px">Daily Quote</Text>
                    <Text fontSize="16px">{pageDataDetail.title[0].value}</Text>
                  </Box>
                </Box>
                <Box mb="20px">
                  <Divider orientation="vertical" borderColor="#aea493" />
                </Box>
                <Box mb="20px">
                  <SocialIcon
                    url={pageDataDetail.url}
                    isVisible={true}
                    direction={'row'}
                    position={'relative'}
                  />
                </Box>

                <Box>
                  <LikeBookmark
                    id={pageDataDetail.uuid}
                    isLiked={pageDataDetail.isLiked}
                    isBookmarked={pageDataDetail.isBookmarked}
                  // updateCards={updateCards}
                  />
                </Box>
              </Flex>
            </Box>
            <Flex
              flexDirection={{
                base: 'column',
                md: 'row',
                sm: 'column',
                lg: 'row',
              }}
              justifyContent="space-around"
              mb="2vw"
              al
            >
              <Box>
                {pageDataDetail.related_tags ? (
                  <Box pos="relative" float="left" w="100%">
                    <RelatedTags tags={pageDataDetail.related_tags} />
                  </Box>
                ) : (
                  ''
                )}
              </Box>
            </Flex>
            <Box>
              <SubscribeContent
                language={language}
                contentSection="wisdom"
                contentType="quotes"
                contentObj={pageDataDetail?.subscription_form}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {isLoader && <Loader />}
      {/* <AdSenseBlock /> */}
    </Box>
  ) : (
    ''
  );
}

export const getStaticPaths = async () => {
  const wisdomLandingPaths = config.USE_LOCAL_URL
    ? [
        '/ta/wisdom/quotes/date/august-12-2022',
        '/ta/wisdom/quotes/date/august-13-2022',
        '/en/wisdom/quotes/date/october-27-2021',
        '/en/wisdom/quotes/date/october-09-2021',
        '/ru/wisdom/quotes/date/october-09-2021',
        '/en/wisdom/quotes/date/september-11-2018',
        '/en/wisdom/quotes/date/january-02-2022',
        '/fa/wisdom/quotes/date/september-21-2024',
      ]
    : await getWisdomLandingPaths('L3', '/date/');
  return {
    paths: wisdomLandingPaths,
    fallback: false
  };
};

export const getStaticProps = async ({
  params: { region = 'in', date = 'september-01-2021' },
  preview,
  previewData,
  req,
}) => {
  const language = region;
  // console.log('getStaticProps', date);
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  // hard coded -- need to make it dynamic later
  const pageDataObj = await fetchBlogDetailData(
    '',
    language,
    'wisdom',
    'quotes',
    date,
    { preview, data: previewData }
  );

  // console.log('pageDataObj', pageDataObj);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data || null,
      pageDataDetail: pageDataObj || null,
      page: date,
      isPreview: preview ? true : false
    }
  };
};
